import SearchIcon from "@mui/icons-material/Search";
import {
  Button,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { type FC } from "react";
import {
  SUMMER_CAMPAIGN_LEAD_CONTACT_STATUSES,
  contactStatusLabel,
} from "@shared/helpers/summer-campaign-lead-communication";

type Props = {
  phoneSearch: string;
  onPhoneSearchChange: (v: string) => void;
  regionFilter: string;
  onRegionFilterChange: (v: string) => void;
  attendanceFilter: string;
  onAttendanceFilterChange: (v: string) => void;
  contactStatusFilter: string;
  onContactStatusFilterChange: (v: string) => void;
  resultCount: number;
};

export const LeadsTableToolbar: FC<Props> = ({
  phoneSearch,
  onPhoneSearchChange,
  regionFilter,
  onRegionFilterChange,
  attendanceFilter,
  onAttendanceFilterChange,
  contactStatusFilter,
  onContactStatusFilterChange,
  resultCount,
}) => {
  const hasFilters = Boolean(
    regionFilter || attendanceFilter || contactStatusFilter || phoneSearch.trim(),
  );

  return (
    <Stack direction="row" gap={1} flexWrap="wrap" alignItems="center">
      <TextField
        size="small"
        placeholder="חיפוש טלפון"
        value={phoneSearch}
        onChange={(e) => onPhoneSearchChange(e.target.value)}
        sx={{ minWidth: 200 }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
      />
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel>אזור</InputLabel>
        <Select
          label="אזור"
          value={regionFilter}
          onChange={(e) => onRegionFilterChange(e.target.value)}
        >
          <MenuItem value="">הכל</MenuItem>
          <MenuItem value="NORTH">צפון</MenuItem>
          <MenuItem value="SOUTH">דרום</MenuItem>
          <MenuItem value="BOTH">צפון ודרום</MenuItem>
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel>נוכחות</InputLabel>
        <Select
          label="נוכחות"
          value={attendanceFilter}
          onChange={(e) => onAttendanceFilterChange(e.target.value)}
        >
          <MenuItem value="">הכל</MenuItem>
          <MenuItem value="GROUP">קבוצה</MenuItem>
          <MenuItem value="INDIVIDUAL">יחיד</MenuItem>
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 140 }}>
        <InputLabel>יצירת קשר</InputLabel>
        <Select
          label="יצירת קשר"
          value={contactStatusFilter}
          onChange={(e) => onContactStatusFilterChange(e.target.value)}
        >
          <MenuItem value="">הכל</MenuItem>
          {SUMMER_CAMPAIGN_LEAD_CONTACT_STATUSES.map((status) => (
            <MenuItem key={status} value={status}>
              {contactStatusLabel(status)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {hasFilters && (
        <Button
          size="small"
          color="inherit"
          onClick={() => {
            onPhoneSearchChange("");
            onRegionFilterChange("");
            onAttendanceFilterChange("");
            onContactStatusFilterChange("");
          }}
        >
          נקה פילטרים
        </Button>
      )}
      <Typography variant="body2" color="text.secondary" sx={{ ml: "auto" }}>
        מציג {resultCount} לידים
      </Typography>
    </Stack>
  );
};
